var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5695 8.586C20.5221 8.47747 20.4557 8.37825 20.3735 8.293L14.3735 2.293C14.2883 2.21078 14.189 2.14441 14.0805 2.097C14.0505 2.083 14.0185 2.075 13.9865 2.064C13.9028 2.03553 13.8157 2.01837 13.7275 2.013C13.7065 2.011 13.6875 2 13.6665 2H6.6665C5.5635 2 4.6665 2.897 4.6665 4V20C4.6665 21.103 5.5635 22 6.6665 22H18.6665C19.7695 22 20.6665 21.103 20.6665 20V9C20.6665 8.979 20.6555 8.96 20.6535 8.938C20.6486 8.84972 20.6314 8.76255 20.6025 8.679C20.5925 8.647 20.5835 8.616 20.5695 8.586ZM17.2525 8H14.6665V5.414L17.2525 8ZM6.6665 20V4H12.6665V9C12.6665 9.26522 12.7719 9.51957 12.9594 9.70711C13.1469 9.89464 13.4013 10 13.6665 10H18.6665L18.6685 20H6.6665Z",
    fill: "#80E88A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 12H16.6665V14H8.6665V12ZM8.6665 16H16.6665V18H8.6665V16ZM8.6665 8H10.6665V10H8.6665V8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileGreen);
export default __webpack_public_path__ + "static/media/file-green.bdd4287c5612008554b2530b13e5f7ce.svg";
export { ForwardRef as ReactComponent };